/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect } from 'react';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { StyledPropertyCardPriceDiv } from './index.style';
import { NAVIGATION_URL_CONSTANTS } from '../../organisms/SearchResults/lib/config';
import { SearchResultDataNode, SearchStateStoreDataType } from '../../organisms/SearchResults/store/store.type';
import {
  DefaultValue,
  RateNodeTypeToBeUsed,
  hardCodedAllLocale,
  STATUS_MAX_OCCUPANCY_EXCEEDED,
  STATUS_NOT_AVAILABLE,
} from '../../organisms/SearchResults/index.constant';
import {
  SearchFilterContext,
  SearchResultAlertContext,
  SearchResultContext,
} from '../../organisms/SearchResults/index.context';
import {
  getAlertsData,
  getCurrentPointSaversRateBlock,
  getCurrentPriceRateBlock,
  getCurrentRatePointsBlock,
  getCurrRateAmountBlock,
  getCurrentRateStrikeThroughBlock,
  getPriceByDecimalPoint,
  getPriceCommaSeparator,
  checkThresholdPercentage,
  updateDatalayerObjViewRates,
  getCurrencyOriginAccordToLocale,
  getRateBlock,
} from '../../organisms/SearchResults/lib/helper';
import CommonUtils from '../../organisms/SearchResults/lib/CommonUtils';
import clsx from 'clsx';
import { PageContext, usePageContext } from '../../context/PageContext/index';
import { useCheckBreakpoint } from '../../hooks/lib/useCheckBreakpoint';
import { addSubDirectoryPrefix, fetchCurrencyToLocale } from '../../utils/src/helper';
import SM from '../../organisms/HotelGalleryTitle/config';
import {
  constructToolTipData,
  identifyTypeOfMandatoryFee,
  mandatoryFeeAvailable,
  mandatoryFeeDescriptionForPoints,
} from '../../modules/utils/ratesHelper';
//TODO : As there is no tooltip component in shared mi-ui-llibrary, we are using it from shop code, as part of 135580 this will be migrated to shared library
import { Tooltip } from '@marriott/mi-ui-library-shop';

export const PropertyCardPriceSection: React.FC<{
  propertyCardData: SearchResultDataNode;
  searchQueryContextValue?: SearchStateStoreDataType; // use for info window only
  staticDataContextValue?: any; // use for info window only
  fromHotelCard?: boolean;
  flexibleSearch?: boolean;
  isSpecialRateSearch?: boolean;
  flexibleOrManyProperty?: boolean;
  recentlyviewedRibbon?: (recentlyViewed: any, setRecentlyViewed: any, id: string) => void;
  setShowStrikeThroughPrice: (flag: boolean) => void;
  showStrikeThroughPrice: boolean;
  setFinalPrice?: (val: string) => void;
  currentLocaleLang?: string;
  HQVSelectedCurrency?: string;
  HQVRateConversionArr?: any;
  HQVRateBlockFlag?: boolean;
  HQVRateReqTypes?: any;
  HQVTaxesandFeeFlag?: boolean;
  miniPropertyCard?: boolean;
  pageNumber?: number;
  idx?: number;
  handleTooltipClick?: any;
  toolTipList?: any;
}> = ({
  propertyCardData,
  staticDataContextValue,
  searchQueryContextValue,
  fromHotelCard,
  flexibleSearch,
  isSpecialRateSearch,
  flexibleOrManyProperty,
  recentlyviewedRibbon,
  setShowStrikeThroughPrice,
  showStrikeThroughPrice,
  setFinalPrice,
  currentLocaleLang,
  HQVSelectedCurrency,
  HQVRateConversionArr,
  HQVRateBlockFlag,
  HQVRateReqTypes,
  HQVTaxesandFeeFlag,
  miniPropertyCard,
  pageNumber,
  idx,
  handleTooltipClick,
  toolTipList,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const {
    jsonContent,
    isErrorState,
    setIsErrorState,
    isMapViewEnabled,
    isFlexibleDateSearch,
    recentlyViewed,
    setRecentlyViewed,
  }: any = useContext(renderedData);
  const pageContext = useContext(PageContext);
  const { searchQueryState } = useContext(SearchFilterContext);
  const { searchResult } = useContext(SearchResultContext);
  const { searchResultAlerts, setSearchResultAlerts } = useContext(SearchResultAlertContext);
  const { currentLocale, NEXT_PUBLIC_AVAILABILITY_SEARCH_URL, sessionData } = usePageContext();
  const staticContent = staticDataContextValue ?? jsonContent;
  const searchState = searchQueryContextValue ?? searchQueryState;
  const currentLocaleVal = currentLocaleLang ?? currentLocale;
  const isShowFullPrice =
    searchState?.includeTaxesAndFees ||
    (sessionData?.data
      ? sessionData?.data?.AriesSearch?.searchCriteria?.showFullPrice === 'true'
        ? true
        : false
      : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.showFullPrice === 'true'
      ? true
      : false);

  const clickTrackingLoc = 'Phoenix Search Results';
  const propertyID = propertyCardData?.node?.property?.id ?? '';
  const currRatePointsBlock = getRateBlock(propertyCardData?.node?.rates, 'points');
  const currRateNode = HQVRateBlockFlag
    ? getCurrentPriceRateBlock(HQVRateReqTypes, propertyCardData?.node?.rates)
    : getCurrentPriceRateBlock(searchState, propertyCardData?.node?.rates);
  const currRate = getCurrRateAmountBlock(currRateNode);
  const mandatoryFeeRates = currRate?.mandatoryFees;

  const currPointsRate = getCurrentRatePointsBlock(propertyCardData?.node?.rates);
  const currEliteDiscountRate = getCurrentRateStrikeThroughBlock(propertyCardData?.node?.rates); // TO-do Optimise it, If strikethorugh, we can avoid points rate calls
  const currPointSaversNode = getCurrentPointSaversRateBlock(propertyCardData?.node?.rates);
  const isViewportL = useCheckBreakpoint('viewportL');
  const ifMandatoryFeeAvailable = () => {
    if (!SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string)) {
      return false;
    } else {
      return isFlexibleDateSearch
        ? null
        : currRate?.mandatoryFees
        ? currRate?.mandatoryFees?.amount !== 0
          ? true
          : false
        : false;
    }
  };

  const pointsValue = flexibleOrManyProperty ? null : currPointsRate?.points ?? null;
  //to check if Points exceeds 5 digits , as a requirement for FSD-75056
  const isPointsExceeds = pointsValue && pointsValue?.toString().length > 5 ? true : false;

  const addDESpecificClassOnMapListSection = () => {
    /**
     * add some specific classes to points section on property card for map view
     * it is specific for de domain because points section required different styling on map view property card
     */
    return currentLocaleVal === hardCodedAllLocale.de && isMapViewEnabled && !miniPropertyCard;
  };
  const addDESpecificClass = () => {
    /**
     * add some specific classes to points section on property card for map view
     * it is specific for de domain because points section required different styling on map view property card
     */
    return currentLocaleVal === hardCodedAllLocale.de && !miniPropertyCard;
  };

  const { currentCurrency } = searchState;
  const selectedCurrency = HQVSelectedCurrency || currentCurrency;
  let priceInfo: any;
  // update logic for priceInfo depending on amountPlusMandatoryFees/amount
  if (
    currRate?.amountPlusMandatoryFees?.amount &&
    SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string)
  ) {
    priceInfo = flexibleOrManyProperty ? null : currRate?.amountPlusMandatoryFees;
  } else {
    priceInfo = flexibleOrManyProperty ? null : currRate?.amount;
  }
  let totalPrice = flexibleOrManyProperty ? null : isShowFullPrice ? currRate?.totalAmount : null;

  //Strikethrough price calculation
  let EEOPriceInfo;
  // update logic for priceInfo depending on amountPlusMandatoryFees/amount
  if (
    currEliteDiscountRate?.amountPlusMandatoryFees?.amount &&
    SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string)
  ) {
    EEOPriceInfo = flexibleOrManyProperty ? null : currEliteDiscountRate?.amountPlusMandatoryFees;
  } else {
    EEOPriceInfo = flexibleOrManyProperty ? null : currEliteDiscountRate?.amount;
  }
  let EEOTotalPrice = flexibleOrManyProperty ? null : isShowFullPrice ? currEliteDiscountRate?.totalAmount : null;

  // update logic for priceInfo depending on amountPlusMandatoryFees/amount
  if (selectedCurrency.toLowerCase() !== DefaultValue) {
    if (
      currRate?.amountPlusMandatoryFees?.amount &&
      SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string)
    ) {
      priceInfo = flexibleOrManyProperty ? null : currRate?.amountPlusMandatoryFees;
    } else {
      priceInfo = flexibleOrManyProperty ? null : currRate?.amount;
    }
    totalPrice = flexibleOrManyProperty ? null : isShowFullPrice ? currRate?.totalAmount : null;
    EEOPriceInfo = flexibleOrManyProperty ? null : currEliteDiscountRate?.amount;
    EEOTotalPrice = flexibleOrManyProperty ? null : isShowFullPrice ? currEliteDiscountRate?.totalAmount : null;
    if (!searchResultAlerts.errorMessage && jsonContent?.alertsListArray) {
      setSearchResultAlerts(getAlertsData(jsonContent?.alertsListArray[2]?.alertCodeListModel[0], 'success'));
    }
  }

  if (currEliteDiscountRate) {
    let showStrikeThroughResult = false;
    if (totalPrice?.amount && EEOTotalPrice?.amount && totalPrice?.amount > EEOTotalPrice?.amount) {
      showStrikeThroughResult = checkThresholdPercentage(totalPrice?.amount, EEOTotalPrice?.amount);
      setShowStrikeThroughPrice(showStrikeThroughResult);

      setFinalPrice &&
        setFinalPrice(
          getPriceByDecimalPoint(
            EEOTotalPrice?.amount,
            EEOTotalPrice?.decimalPoint,
            searchState,
            currentLocaleVal,
            EEOTotalPrice?.currency,
            HQVRateConversionArr,
            HQVSelectedCurrency
          )?.toString()
        );
    } else if (priceInfo?.amount && EEOPriceInfo?.amount && priceInfo?.amount > EEOPriceInfo?.amount) {
      showStrikeThroughResult = checkThresholdPercentage(priceInfo?.amount, EEOPriceInfo?.amount);
      setShowStrikeThroughPrice(showStrikeThroughResult);
      setFinalPrice &&
        setFinalPrice(
          getPriceByDecimalPoint(
            EEOPriceInfo?.amount,
            EEOPriceInfo?.decimalPoint,
            searchState,
            currentLocaleVal,
            EEOPriceInfo?.currency,
            HQVRateConversionArr,
            HQVSelectedCurrency
          )?.toString()
        );
    }
  }

  const pointsSaverFlag = currPointSaversNode;

  //added since builds are failing
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let isHotelMaxOccupancyExceeded = false;
    let isHotelUnavailable = false;
    if (isErrorState) {
      if (
        !isFlexibleDateSearch &&
        (currRateNode?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
          currRatePointsBlock?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED)
      ) {
        isHotelMaxOccupancyExceeded = true;
      }

      if (
        !isFlexibleDateSearch &&
        !(currRateNode?.rateAmounts?.length || currRatePointsBlock?.rateAmounts?.length) &&
        propertyCardData?.node?.property?.basicInformation?.openingDate &&
        (currRateNode?.status?.code === STATUS_NOT_AVAILABLE ||
          currRatePointsBlock?.status?.code === STATUS_NOT_AVAILABLE)
      ) {
        isHotelUnavailable = true;
      }

      if (
        pointsValue ||
        totalPrice?.amount ||
        priceInfo?.amount ||
        isFlexibleDateSearch ||
        flexibleOrManyProperty ||
        isHotelMaxOccupancyExceeded ||
        isHotelUnavailable
      ) {
        setIsErrorState(false);
      }
    }
  }, []);

  const handleClick = () => {
    if (recentlyviewedRibbon && !HQVRateBlockFlag) {
      recentlyviewedRibbon(recentlyViewed, setRecentlyViewed, propertyID ? propertyID.toString() : ' ');
    }
  };
  const currentViewIsTab = CommonUtils.isTabletView();
  const currentViewIsMobile = CommonUtils.isOnlyMobileView();
  const { isResort, isLACountyFee, isDestinationFee } = identifyTypeOfMandatoryFee(
    propertyCardData?.node?.property?.basicInformation
  );
  const { toolTipTitle } = constructToolTipData(isResort, isLACountyFee, isDestinationFee, staticContent);

  const isMandatoryFeeAvailable = mandatoryFeeAvailable(
    currRate,
    SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string),
    flexibleOrManyProperty ? true : false
  );
  const tooltipSubheading = toolTipTitle + ' ' + staticContent?.includesLabel + ':';
  return (
    <StyledPropertyCardPriceDiv>
      {
        <div
          role="term"
          tabIndex={0}
          {...(HQVRateBlockFlag
            ? { className: 'hqv-price-component' }
            : { className: 'analytics-click custom_click_track property-card-price-component' })}
          {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
        >
          {pointsValue ? (
            <div
              className={clsx(HQVRateBlockFlag ? 'hqv-rate-container' : '', 'rate-container')}
              data-testid={'pointscard-testid'}
              onClick={() =>
                updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch, HQVRateBlockFlag)
              }
            >
              <div
                className={clsx(
                  'points-section',
                  HQVRateBlockFlag && 'ml-3 hqv-modal-points-styling',
                  pointsSaverFlag ? 'points-saver' : 'non-saver',
                  addDESpecificClass() ? 'points-de-section' : ''
                )}
              >
                {pointsSaverFlag && (
                  <div
                    className={clsx(
                      currentViewIsTab && isMapViewEnabled ? 'mb-n1' : '',
                      't-label-alt-xs points-saver-label text-left'
                    )}
                  >
                    {staticContent?.pointsSaverLabel}
                  </div>
                )}
                <a
                  {...(!HQVRateBlockFlag
                    ? {
                        className: 'analytics-click custom_click_track ',
                      }
                    : '')}
                  {...(HQVRateBlockFlag
                    ? { href: 'javascript:void(0)' }
                    : {
                        href: `${addSubDirectoryPrefix(
                          `${NEXT_PUBLIC_AVAILABILITY_SEARCH_URL}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
                        )}${propertyID}&isSearch=true&showFullPrice=${isShowFullPrice}${
                          selectedCurrency !== 'default' ? '&redirectedFromSERP=true' : ''
                        }`,
                      })}
                  onClick={handleClick}
                  data-testid={'propertycard-testid-points'}
                  {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
                >
                  <div
                    className={clsx(
                      (currentLocale === 'ru-RU' || currentLocale === 'pt-BR') &&
                        !HQVRateBlockFlag &&
                        (currentViewIsMobile || currentViewIsTab)
                        ? 'ru-specific-price-section'
                        : 'price-section',
                      isPointsExceeds ? 'price-section-display-block' : '',
                      (pointsSaverFlag && !HQVRateBlockFlag) || (totalPrice?.amount && HQVRateBlockFlag)
                        ? 'justify-content-start'
                        : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : '',
                      addDESpecificClassOnMapListSection() ? 'points-value-de-section' : ''
                    )}
                  >
                    <div
                      className={clsx(
                        'm-price points-value',
                        currentLocale === 'ru-RU' && !HQVRateBlockFlag && (currentViewIsMobile || currentViewIsTab)
                          ? 'ru-specific-line-height'
                          : '',
                        pointsSaverFlag ? `points-saver` : ``,
                        addDESpecificClassOnMapListSection() ? 'points-value-de' : ''
                      )}
                    >
                      {getPriceCommaSeparator(pointsValue, searchState, currentLocaleVal, HQVSelectedCurrency)}
                    </div>
                    <div
                      className={clsx(
                        pointsSaverFlag ? `t-label-xs` : `t-label-alt-xs`,
                        'points-currency-label',
                        addDESpecificClassOnMapListSection() ? 'points-value-de-label' : ''
                      )}
                      {...(HQVRateBlockFlag ? {} : { role: 'button' })}
                    >
                      {staticContent?.pointsPerStayLabel}
                    </div>
                  </div>
                </a>
                {isMandatoryFeeAvailable &&
                toolTipTitle !== '' &&
                !totalPrice?.amount &&
                (currentViewIsTab || (!currentViewIsTab && !fromHotelCard)) ? (
                  <div
                    className={clsx(
                      currentViewIsTab
                        ? isMapViewEnabled
                          ? pointsSaverFlag
                            ? 'mt-n1'
                            : ''
                          : 'mt-n1'
                        : isMapViewEnabled
                        ? 'mt-n1'
                        : currentViewIsMobile
                        ? 'mt-n1'
                        : !HQVRateBlockFlag
                        ? toolTipList?.length
                          ? pointsSaverFlag
                            ? 'mt-n2'
                            : 'mt-n1'
                          : 'mt-n1'
                        : '',
                      !HQVRateBlockFlag ? 'points-mandatory-fee-section' : 'points-mandatory-fee-section-hqv',
                      pointsSaverFlag ? 'justify-content-start text-left' : '',
                      !pointsSaverFlag ? 'text-right' : pointsSaverFlag && isMapViewEnabled ? 'pb-1' : ''
                    )}
                  >
                    <span
                      className={clsx(
                        't-font-alt-xs',
                        !currentViewIsTab ? 'pt-1' : '',
                        pointsSaverFlag && isMapViewEnabled && !fromHotelCard ? '' : 'text-right',
                        HQVRateBlockFlag && !pointsSaverFlag ? 'justify-content-end' : '',
                        currentViewIsTab && pointsSaverFlag
                          ? `d-flex align-items-baseline ${
                              HQVRateBlockFlag ? 'justify-content-end' : 'justify-content-start'
                            } `
                          : '',
                        currentViewIsTab && pointsSaverFlag ? (!isMapViewEnabled ? 'pb-0' : '') : ''
                      )}
                    >
                      <span className={clsx(pointsSaverFlag ? 'points-mandatory-fee-text' : '')}>
                        {mandatoryFeeDescriptionForPoints(
                          mandatoryFeeRates,
                          searchQueryState,
                          currentLocale,
                          propertyCardData,
                          staticContent,
                          selectedCurrency,
                          HQVRateConversionArr,
                          HQVSelectedCurrency,
                          pointsSaverFlag,
                          currentViewIsTab,
                          HQVRateBlockFlag
                        )}
                      </span>
                      <span className={clsx('nowrap-tooltip', 'pl-1')}>
                        {!currentViewIsTab || (currentViewIsTab && !pointsSaverFlag) || HQVRateBlockFlag
                          ? `${staticContent?.feeLabel} `
                          : ''}
                        <span
                          data-testid={'mandatory-fee-points-tooltip'}
                          tabIndex={0}
                          role="button"
                          onKeyDown={(e): void => {
                            if (e.key === 'Enter' || e.keyCode === 13) {
                              e.preventDefault();
                              handleTooltipClick(e);
                            }
                          }}
                          aria-label={`${mandatoryFeeDescriptionForPoints(
                            mandatoryFeeRates,
                            searchQueryState,
                            currentLocale,
                            propertyCardData,
                            staticContent,
                            selectedCurrency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency,
                            pointsSaverFlag,
                            currentViewIsTab,
                            HQVRateBlockFlag
                          )}${
                            !currentViewIsTab || (currentViewIsTab && !pointsSaverFlag) || HQVRateBlockFlag
                              ? ` ${staticContent?.feeLabel} `
                              : ''
                          }`}
                          onClick={(e): void => {
                            e.preventDefault();
                            handleTooltipClick(e);
                          }}
                          className={clsx(
                            !HQVRateBlockFlag ? 'icon-information' : '',
                            't-font-alt-s',
                            'point-savers-mandatory-fee-icon-map-view',
                            !toolTipList?.length ? 'd-none' : '',
                            isMapViewEnabled || currentViewIsMobile || currentViewIsTab
                              ? 'points-mandatory-fee-icon-mobile-and-map'
                              : ''
                          )}
                        >
                          {HQVRateBlockFlag && (
                            <Tooltip
                              optionalClassName="hqv-mandatoryfee-tooltip"
                              tooltipData={toolTipList}
                              clickTrackingString={`${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`}
                              tooltipParaText={tooltipSubheading}
                              classForTooltipContainer={'d-inline'}
                            />
                          )}
                        </span>
                      </span>
                    </span>
                  </div>
                ) : (
                  <></>
                )}
                {totalPrice?.amount ? (
                  <div
                    className={clsx(
                      'd-flex flex-column currency-section m-price-currency-s t-font-alt-s ',
                      addDESpecificClassOnMapListSection() ? 'points-de-currency-section' : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : ''
                    )}
                  >
                    <div className={clsx('d-flex', 'price-section-color', 'price-value-section')}>
                      <div className={clsx(pointsSaverFlag ? `t-font-xs` : `t-font-alt-xs`, 'price-value')}>
                        {getPriceByDecimalPoint(
                          totalPrice?.amount,
                          totalPrice?.decimalPoint,
                          searchState,
                          currentLocaleVal,
                          totalPrice?.currency,
                          HQVRateConversionArr,
                          HQVSelectedCurrency
                        )}
                      </div>
                      <div
                        className={clsx(
                          pointsSaverFlag ? `t-font-xs` : `t-font-alt-xs`,
                          ' currency-label',
                          HQVTaxesandFeeFlag ? 'taxes-currency-label' : ''
                        )}
                        tabIndex={0}
                        {...(HQVRateBlockFlag ? {} : { role: 'button' })}
                      >
                        {`${
                          selectedCurrency.toLowerCase() !== DefaultValue
                            ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
                            : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, totalPrice?.currency)
                        } ${staticContent?.perNightLabel}`}
                      </div>
                    </div>
                    {!currentViewIsTab && !fromHotelCard && (
                      <div className={clsx('t-font-xs taxes-and-fees-included')}>
                        {staticContent?.taxesAndFeesIncluded}
                      </div>
                    )}
                    {currentViewIsTab && (
                      <div className={clsx('t-font-xs taxes-and-fees-included')}>
                        {staticContent?.taxesAndFeesIncluded}
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                )}
                {priceInfo?.amount && !totalPrice?.amount ? (
                  <div
                    className={clsx(
                      'currency-section m-price-currency-s',
                      addDESpecificClassOnMapListSection() ? 'points-de-currency-section' : '',
                      !HQVRateBlockFlag && (isMapViewEnabled || currentViewIsTab)
                        ? 'price-section-map-view-max-width'
                        : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : ''
                    )}
                  >
                    <div
                      className={clsx(`t-font-alt-xs`, 'm-price-currency-s')}
                      {...(HQVRateBlockFlag ? {} : { role: 'button' })}
                    >
                      {getPriceByDecimalPoint(
                        priceInfo?.amount,
                        priceInfo?.decimalPoint,
                        searchState,
                        currentLocaleVal,
                        priceInfo?.currency,
                        HQVRateConversionArr,
                        HQVSelectedCurrency
                      )}{' '}
                      {`${
                        selectedCurrency.toLowerCase() !== DefaultValue
                          ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
                          : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, priceInfo?.currency)
                      } ${staticContent?.perNightLabel} 
                      ${
                        isMandatoryFeeAvailable && toolTipTitle !== ''
                          ? `${staticContent?.includesLabel?.toLowerCase()} ${staticContent?.dailyLabel?.toLowerCase()} ${staticContent?.feeLabel?.toLowerCase()}`
                          : ''
                      } 
                      `}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          ) : (
            ''
          )}

          {!pointsValue && totalPrice?.amount ? (
            <a
              {...(!HQVRateBlockFlag
                ? {
                    className: 'analytics-click custom_click_track ',
                  }
                : '')}
              {...(HQVRateBlockFlag
                ? { href: 'javascript:void(0)' }
                : {
                    href: `${addSubDirectoryPrefix(
                      `${NEXT_PUBLIC_AVAILABILITY_SEARCH_URL}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
                    )}${propertyID}&isSearch=true&showFullPrice=${isShowFullPrice}${
                      selectedCurrency !== 'default' ? '&redirectedFromSERP=true' : ''
                    }`,
                  })}
              onClick={handleClick}
              data-testid={'propertycard-testid-taxes'}
              {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
            >
              <div
                className={clsx(HQVRateBlockFlag ? 'hqv-rate-container' : '', 'rate-container')}
                onClick={() =>
                  updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch, HQVRateBlockFlag)
                }
              >
                <div className={clsx('taxes-and-fees-section')}>
                  <div className="price-section">
                    <span
                      className={clsx(
                        'price-value',
                        showStrikeThroughPrice &&
                          fromHotelCard &&
                          EEOTotalPrice?.amount &&
                          totalPrice?.amount > EEOTotalPrice?.amount &&
                          getPriceByDecimalPoint(
                            EEOTotalPrice?.amount,
                            EEOTotalPrice?.decimalPoint,
                            searchState,
                            currentLocaleVal,
                            EEOTotalPrice?.currency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency
                          ).split('').length <= 4
                          ? 'map-currency-value'
                          : isMapViewEnabled &&
                            getPriceByDecimalPoint(
                              priceInfo?.amount,
                              priceInfo?.decimalPoint,
                              searchState,
                              currentLocaleVal,
                              priceInfo?.currency,
                              HQVRateConversionArr,
                              HQVSelectedCurrency
                            ).split('').length >= 7
                          ? 'd-flex flex-column align-items-end'
                          : 'currency-value amount-display'
                      )}
                    >
                      <span
                        className={clsx(
                          'price-value',
                          showStrikeThroughPrice &&
                            fromHotelCard &&
                            EEOTotalPrice?.amount &&
                            totalPrice?.amount > EEOTotalPrice?.amount &&
                            getPriceByDecimalPoint(
                              EEOTotalPrice?.amount,
                              EEOTotalPrice?.decimalPoint,
                              searchState,
                              currentLocaleVal,
                              EEOTotalPrice?.currency,
                              HQVRateConversionArr,
                              HQVSelectedCurrency
                            ).split('').length <= 4
                            ? 'map-price-value'
                            : ''
                        )}
                      >
                        {showStrikeThroughPrice &&
                          EEOTotalPrice?.amount &&
                          totalPrice?.amount > EEOTotalPrice?.amount && (
                            <span
                              className={clsx(
                                ifMandatoryFeeAvailable() ? 'striked-mandatory-fee' : '',
                                'strike-through'
                              )}
                            >
                              <div
                                className={clsx(
                                  't-label-xs',
                                  'eeo-price-value',
                                  fromHotelCard &&
                                    getPriceByDecimalPoint(
                                      EEOTotalPrice?.amount,
                                      EEOTotalPrice?.decimalPoint,
                                      searchState,
                                      currentLocaleVal,
                                      EEOTotalPrice?.currency,
                                      HQVRateConversionArr,
                                      HQVSelectedCurrency
                                    ).split('').length <= 3
                                    ? 'strike-through-component'
                                    : ''
                                )}
                              >
                                {staticContent.previousEEORateLabel}{' '}
                                {getPriceByDecimalPoint(
                                  totalPrice?.amount,
                                  totalPrice?.decimalPoint,
                                  searchState,
                                  currentLocaleVal,
                                  totalPrice?.currency,
                                  HQVRateConversionArr,
                                  HQVSelectedCurrency
                                )}
                              </div>
                            </span>
                          )}
                        <span
                          className="m-price"
                          role="button"
                          aria-label={`
                          ${staticContent?.newEEORateLabel}
                          ${
                            showStrikeThroughPrice && EEOTotalPrice?.amount
                              ? getPriceByDecimalPoint(
                                  EEOTotalPrice?.amount,
                                  EEOTotalPrice?.decimalPoint,
                                  searchState,
                                  currentLocaleVal,
                                  EEOPriceInfo?.currency,
                                  HQVRateConversionArr,
                                  HQVSelectedCurrency
                                )
                              : getPriceByDecimalPoint(
                                  totalPrice?.amount,
                                  totalPrice?.decimalPoint,
                                  searchState,
                                  currentLocaleVal,
                                  totalPrice?.currency,
                                  HQVRateConversionArr,
                                  HQVSelectedCurrency
                                )
                          }

                         `}
                        >
                          {showStrikeThroughPrice && EEOTotalPrice?.amount && (
                            <span role="button" aria-label={staticContent.newEEORateLabel}></span>
                          )}
                          {showStrikeThroughPrice && EEOTotalPrice?.amount
                            ? getPriceByDecimalPoint(
                                EEOTotalPrice.amount,
                                EEOTotalPrice.decimalPoint,
                                searchState,
                                currentLocaleVal,
                                EEOTotalPrice?.currency,
                                HQVRateConversionArr,
                                HQVSelectedCurrency
                              )
                            : getPriceByDecimalPoint(
                                totalPrice.amount,
                                totalPrice.decimalPoint,
                                searchState,
                                currentLocaleVal,
                                totalPrice?.currency,
                                HQVRateConversionArr,
                                HQVSelectedCurrency
                              )}
                        </span>
                      </span>
                      <span
                        className={clsx(
                          HQVTaxesandFeeFlag ? 'taxes-currency-label' : '',
                          getPriceByDecimalPoint(
                            totalPrice.amount,
                            totalPrice.decimalPoint,
                            searchState,
                            currentLocaleVal,
                            totalPrice?.currency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency
                          ).split('').length <= 4
                            ? 'currency-label'
                            : addDESpecificClassOnMapListSection() && isViewportL
                            ? 'd-block'
                            : '',
                          'idr-currency-label',
                          't-label-xs'
                        )}
                        tabIndex={0}
                        role="region"
                      >
                        {` ${
                          selectedCurrency.toLowerCase() !== DefaultValue
                            ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
                            : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, totalPrice?.currency)
                        } ${staticContent?.perNightLabel}`}
                      </span>
                    </span>
                  </div>
                  {(searchState?.includeTaxesAndFees || HQVTaxesandFeeFlag) && !currentViewIsTab && !fromHotelCard && (
                    <div
                      className={clsx(
                        't-font-xs taxes-and-fees-included',
                        addDESpecificClassOnMapListSection() ? 'text-overflow-ellipsis taxes-and-fees-de' : ''
                      )}
                    >
                      {staticContent?.taxesAndFeesIncluded}
                    </div>
                  )}
                  {(searchState?.includeTaxesAndFees || HQVTaxesandFeeFlag) && currentViewIsTab && (
                    <div className="t-font-xs taxes-and-fees-included">{staticContent?.taxesAndFeesIncluded}</div>
                  )}
                </div>
              </div>
            </a>
          ) : (
            ''
          )}
          {!pointsValue && !totalPrice?.amount && priceInfo?.amount ? (
            <a
              {...(!HQVRateBlockFlag
                ? {
                    className: 'analytics-click custom_click_track ',
                  }
                : '')}
              {...(HQVRateBlockFlag
                ? { href: 'javascript:void(0)' }
                : {
                    href: `${addSubDirectoryPrefix(
                      `${NEXT_PUBLIC_AVAILABILITY_SEARCH_URL}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
                    )}${propertyID}&isSearch=true&showFullPrice=${isShowFullPrice}${
                      selectedCurrency !== 'default' ? '&redirectedFromSERP=true' : ''
                    }`,
                  })}
              onClick={handleClick}
              data-testid={'propertycard-testid-cash'}
              {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
            >
              <div
                className={clsx(HQVRateBlockFlag ? 'hqv-rate-container' : '', 'rate-container')}
                onClick={() =>
                  updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch, HQVRateBlockFlag)
                }
              >
                <span
                  className={clsx(
                    'price-value',
                    showStrikeThroughPrice &&
                      fromHotelCard &&
                      EEOPriceInfo?.amount &&
                      priceInfo?.amount > EEOPriceInfo?.amount &&
                      getPriceByDecimalPoint(
                        EEOPriceInfo?.amount,
                        EEOPriceInfo?.decimalPoint,
                        searchState,
                        currentLocaleVal,
                        EEOPriceInfo?.currency,
                        HQVRateConversionArr,
                        HQVSelectedCurrency
                      ).split('').length <= 4
                      ? 'map-currency-value '
                      : isMapViewEnabled &&
                        getPriceByDecimalPoint(
                          priceInfo?.amount,
                          priceInfo?.decimalPoint,
                          searchState,
                          currentLocaleVal,
                          priceInfo?.currency,
                          HQVRateConversionArr,
                          HQVSelectedCurrency
                        ).split('').length > 7
                      ? 'd-flex flex-column align-items-end'
                      : 'currency-value amount-display',
                    currentLocale === 'ru-RU' &&
                      !HQVRateBlockFlag &&
                      (currentViewIsMobile || currentViewIsTab) &&
                      (selectedCurrency?.toLocaleLowerCase() === 'krw' ||
                        selectedCurrency?.toLocaleLowerCase() === 'idr')
                      ? 'ru-specific-price-section'
                      : ''
                  )}
                >
                  <span
                    className={clsx(
                      'price-value',
                      showStrikeThroughPrice &&
                        fromHotelCard &&
                        EEOPriceInfo?.amount &&
                        priceInfo?.amount > EEOPriceInfo?.amount &&
                        getPriceByDecimalPoint(
                          EEOPriceInfo?.amount,
                          EEOPriceInfo?.decimalPoint,
                          searchState,
                          currentLocaleVal,
                          EEOPriceInfo?.currency,
                          HQVRateConversionArr,
                          HQVSelectedCurrency
                        ).split('').length <= 4
                        ? 'map-price-value'
                        : ''
                    )}
                  >
                    {showStrikeThroughPrice && EEOPriceInfo?.amount && priceInfo?.amount > EEOPriceInfo?.amount && (
                      <span
                        className={clsx(ifMandatoryFeeAvailable() ? 'striked-mandatory-fee' : '', 'strike-through')}
                      >
                        <div
                          className={clsx(
                            't-label-xs',
                            'eeo-price-value',
                            fromHotelCard &&
                              getPriceByDecimalPoint(
                                EEOPriceInfo?.amount,
                                EEOPriceInfo?.decimalPoint,
                                searchState,
                                currentLocaleVal,
                                EEOPriceInfo?.currency,
                                HQVRateConversionArr,
                                HQVSelectedCurrency
                              ).split('').length <= 3
                              ? 'strike-through-component'
                              : ''
                          )}
                        >
                          {staticContent.previousEEORateLabel}{' '}
                          {getPriceByDecimalPoint(
                            priceInfo?.amount,
                            priceInfo?.decimalPoint,
                            searchState,
                            currentLocaleVal,
                            priceInfo?.currency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency
                          )}
                        </div>
                      </span>
                    )}
                    <span
                      className="m-price"
                      role="button"
                      aria-label={`
                    ${staticContent?.newEEORateLabel}
                      ${
                        showStrikeThroughPrice && EEOPriceInfo?.amount
                          ? getPriceByDecimalPoint(
                              EEOPriceInfo?.amount,
                              EEOPriceInfo?.decimalPoint,
                              searchState,
                              currentLocaleVal,
                              EEOPriceInfo?.currency,
                              HQVRateConversionArr,
                              HQVSelectedCurrency
                            )
                          : getPriceByDecimalPoint(
                              priceInfo?.amount,
                              priceInfo?.decimalPoint,
                              searchState,
                              currentLocaleVal,
                              priceInfo?.currency,
                              HQVRateConversionArr,
                              HQVSelectedCurrency
                            )
                      }

                    `}
                    >
                      {showStrikeThroughPrice && EEOPriceInfo?.amount && (
                        <span role="button" aria-label={staticContent.newEEORateLabel}></span>
                      )}
                      {showStrikeThroughPrice && EEOPriceInfo?.amount
                        ? getPriceByDecimalPoint(
                            EEOPriceInfo.amount,
                            EEOPriceInfo.decimalPoint,
                            searchState,
                            currentLocaleVal,
                            EEOPriceInfo?.currency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency
                          )
                        : getPriceByDecimalPoint(
                            priceInfo.amount,
                            priceInfo.decimalPoint,
                            searchState,
                            currentLocaleVal,
                            priceInfo?.currency,
                            HQVRateConversionArr,
                            HQVSelectedCurrency
                          )}
                    </span>
                  </span>
                  <span
                    className={clsx(
                      getPriceByDecimalPoint(
                        priceInfo.amount,
                        priceInfo.decimalPoint,
                        searchState,
                        currentLocaleVal,
                        priceInfo?.currency,
                        HQVRateConversionArr,
                        HQVSelectedCurrency
                      ).split('').length <= 4
                        ? 'currency-label'
                        : 'idr-currency-label',
                      HQVRateBlockFlag ? `t-font-m` : `t-label-xs`
                    )}
                    role="button"
                    aria-label={` ${
                      selectedCurrency.toLowerCase() !== DefaultValue
                        ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
                        : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, priceInfo?.currency)
                    } ${staticContent?.perNightLabel}`}
                  >
                    {`${
                      selectedCurrency.toLowerCase() !== DefaultValue
                        ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
                        : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, priceInfo?.currency)
                    } ${staticContent?.perNightLabel}`}
                  </span>
                </span>
              </div>
            </a>
          ) : (
            ''
          )}

          {!pointsValue && !totalPrice?.amount && !priceInfo?.amount && !flexibleSearch && !flexibleOrManyProperty ? (
            <a
              {...(!HQVRateBlockFlag
                ? {
                    className: 'analytics-click custom_click_track ',
                  }
                : '')}
              {...(HQVRateBlockFlag
                ? { href: 'javascript:void(0)' }
                : {
                    href: `${addSubDirectoryPrefix(
                      `${NEXT_PUBLIC_AVAILABILITY_SEARCH_URL}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
                    )}${propertyID}&isSearch=true&showFullPrice=${isShowFullPrice}${
                      selectedCurrency !== 'default' ? '&redirectedFromSERP=true' : ''
                    }`,
                  })}
              onClick={handleClick}
              data-testid={'propertycard-testid-unavailable'}
              {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
            >
              <div
                className={clsx('t-label-xs', 'currency-label', 'rate-unavailable')}
                tabIndex={0}
                {...(HQVRateBlockFlag ? {} : { role: 'button' })}
              >
                {fromHotelCard
                  ? isSpecialRateSearch
                    ? jsonContent.rateUnavailableLabel
                    : jsonContent?.soldOutLabel
                  : staticContent?.rateUnavailableLabel}
              </div>
            </a>
          ) : (
            ''
          )}
          {(flexibleSearch || flexibleOrManyProperty) && (
            <div className={clsx('t-label-xs', 'currency-label', 'rate-unavailable')}></div>
          )}
        </div>
      }
    </StyledPropertyCardPriceDiv>
  );
};
